export const PAGE_NAMES = {
  new: '新しい投稿を追加',
  login: 'ログイン',
  signup: 'アカウント作成',
  admin: 'マイページ',
  myArticles: 'マイ投稿一覧',
  likedArticles: 'お気に入り一覧',
  accountSettings: 'アカウント設定',
  profileEdit: 'プロフィール変更',
  passwordChange: 'パスワード変更',
  deactivateAccount: 'アカウント削除',
  articles: '投稿一覧＆検索',
  passwordInitialize: 'パスワード初期化',
  verifyEmail: 'メールアドレス確認',
  notFound: 'ページが見つかりません',
  internalError: 'エラーが発生しました',
  inquiry: 'お問い合わせ',
  terms: '利用規約',
  privacy: 'プライバシーポリシー',
  specialMap: 'オリジナルマップ',
  specialMapNew: '新規オリジナルマップ作成',
  specialMapManage: 'マイオリジナルマップ一覧',
};
